let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("clNzN")).then(() => parcelRequire('kXViC'));